import { render, staticRenderFns } from "./EntryShow_Desktop.vue?vue&type=template&id=4b8b9241&"
import script from "./EntryShow_Desktop.vue?vue&type=script&lang=js&"
export * from "./EntryShow_Desktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports